import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { IOfficeConsentApi, IOfficeConsentApiResponse } from '../types/OfficeConsent.api';
import type { IGetOfficeConsentParameters } from '../types/OfficeConsent.parameters';

export const getOfficeConsent = async (
  params: IGetOfficeConsentParameters,
): Promise<IOfficeConsentApi> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IOfficeConsentApiResponse>(
    `/credential-service/offices/${params.officeId}/consents/${params.code}`,
    { headers },
  );

  return response.data.data;
};
